import { Item, Step } from 'modules/processes/domain'

import ActionWizard from './Actions'
import { ActionWizardProvider } from './Actions/ActionProvider'
import { FeaturesProvider } from './Providers/features'
import { FormProvider } from './Providers/form'
import { ItemProvider } from './Providers/item'
import { PreviewProvider } from './Providers/preview'
import { ValidationsProvider } from './Providers/validations'
import TaskWizard from './Tasks'
import { TaskWizardProvider } from './Tasks/TaskProvider'

export type WizardTypes = 'task' | 'action'

export enum ItemConfigurationType {
  'Processes::Action' = 'Processes::Action',
  'Processes::TaskConfiguration' = 'Processes::TaskConfiguration',
}

const ItemTypeToWizardType: Record<string, WizardTypes> = {
  [ItemConfigurationType['Processes::Action']]: 'action',
  [ItemConfigurationType['Processes::TaskConfiguration']]: 'task',
}

export const mapItemTypeToWizardType = (type?: string | null): WizardTypes => {
  const foundType = Object.entries(ItemConfigurationType).find(([_, value]) => value === type)

  if (!foundType) return 'task'

  const wizardType = ItemTypeToWizardType[foundType[1]]
  return wizardType ?? 'task'
}

type Props = {
  item?: Item
  stepId?: number
  steps?: Step[]
  type: WizardTypes | null
  onClose: () => void
}

const ItemWizard = ({ steps, item, stepId, type, onClose }: Props) => {
  const currentStep = steps?.find((step) => Number(step.id) === Number(stepId))

  if (!currentStep) return null

  return (
    <ItemProvider item={item}>
      <FormProvider item={item} stepId={Number(stepId)} currentStep={currentStep}>
        <FeaturesProvider>
          <ValidationsProvider>
            <PreviewProvider>
              {type === 'task' && (
                <TaskWizardProvider>
                  <TaskWizard onClose={onClose} item={item} />
                </TaskWizardProvider>
              )}
              {type === 'action' && (
                <ActionWizardProvider>
                  <ActionWizard onClose={onClose} item={item} />
                </ActionWizardProvider>
              )}
            </PreviewProvider>
          </ValidationsProvider>
        </FeaturesProvider>
      </FormProvider>
    </ItemProvider>
  )
}

export default ItemWizard
